import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import API from "../api";
import { selectUser } from "../store/authSlice";
import "./css/teams.css";

function Avatar({ name, src }) {
  const initials = (name || "U")
    .split(/\s+/)
    .slice(0, 2)
    .map(s => s[0]?.toUpperCase())
    .join("") || "U";

  if (src) {
    return (
      <div className="tm-avatar">
        <img src={src} alt={name || "User"} />
      </div>
    );
  }
  return (
    <div className="tm-avatar tm-avatar--fallback" aria-label={name}>
      {initials}
    </div>
  );
}

function OneCard({ u }) {
  return (
    <div className="tm-card">
      <div className="tm-card__head">
        <Avatar name={u.username} src={u.photo_url} />
        <div className="tm-card__title">
          <div className="tm-name">{u.username || "Unnamed"}</div>
          <div className="tm-sub">
            <span className="tm-role">{u.role || "user"}</span>
            <span className="tm-dot">•</span>
            <span className="tm-ass">ASS {u.ass ?? "—"}</span>
          </div>
        </div>
      </div>

      <div className="tm-card__body">
        <div className="tm-row">
          <span className="tm-key">Email</span>
          <a className="tm-val tm-link" href={`mailto:${u.email || ""}`}>
            {u.email || "—"}
          </a>
        </div>
        <div className="tm-row">
          <span className="tm-key">Mobile</span>
          <span className="tm-val">{u.mobile || "—"}</span>
        </div>
      </div>

      <div className="tm-card__foot">
        <span className={`tm-status ${String(u.status || "").toLowerCase().includes("active") ? "is-ok" : ""}`}>
          {u.status || "—"}
        </span>
        <div className="tm-actions">
          <button className="tm-icon" title="Message">💬</button>
          <button className="tm-icon" title="Call">📞</button>
          <button className="tm-icon" title="More">⋯</button>
        </div>
      </div>
    </div>
  );
}

export default function Teams() {
  const user = useSelector(selectUser);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    let gone = false;
    (async () => {
      try {
        setLoading(true);
        setErr("");
        // token on cookie; API baseURL already has /api
   
        const resp = await API.get("/auth/team", {
         params: {
           role: (user?.role || "").toLowerCase(),
           ass:  user?.ass ?? 2,          // default 2 when null/undefined
         }
       });
        const list = Array.isArray(resp?.data) ? resp.data : [];
        if (!gone) setRows(list);
      } catch (e) {
        console.error(e);
        if (!gone) setErr("Could not load team.");
      } finally {
        if (!gone) setLoading(false);
      }
    })();
    return () => { gone = true; };
  }, [user?.role, user?.ass]);

  return (
    <div className="tm-wrap">
      <div className="tm-header">
        <h2 className="tm-h2">Team</h2>
        <div className="tm-subhead">
          {user?.role?.toLowerCase() === "admin" ? "All users" : `Your group (ASS ${user?.ass ?? "—"})`}
        </div>
      </div>

      {loading && <div className="tm-empty">Loading…</div>}
      {err && <div className="tm-error">{err}</div>}

      {!loading && !err && rows.length === 0 && (
        <div className="tm-empty">No team members found.</div>
      )}

      {!loading && !err && rows.length > 0 && (
        <div className="tm-grid">
          {rows.map(u => <OneCard key={u.id} u={u} />)}
        </div>
      )}
    </div>
  );
}
